import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'

import useStyles from './styles'

const Combo = ({ children, singleHelperText, className }) => {
  const classes = useStyles()

  return (
    <Box
      className={clsx(
        classes.combo,
        singleHelperText && 'singleHelperText',
        className,
      )}
    >
      {children}
    </Box>
  )
}

Combo.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  singleHelperText: PropTypes.bool,
}

export default Combo
